// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer-module--footer--3WRuH","link":"Footer-module--link--2xE0O","separator":"Footer-module--separator--2c6L1"};